import { Type } from "class-transformer";
import { IsInt, IsNotEmpty, IsOptional, IsString, Min } from "class-validator";

import { IJudgeEntryLimit } from "./judge-entry-limit.interface";

export class JudgeEntryLimitDto implements IJudgeEntryLimit {
  @IsString()
  @IsNotEmpty()
  judge_name: string;

  @IsOptional()
  @IsString()
  judge_number?: string;

  @Type(() => Number)
  @IsInt()
  @Min(1)
  total_entries: number;

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(0)
  manual_entries?: number;
}
